import JassEnum from './enum';

/**
 * type weapontype
 */
export default class JassWeaponType extends JassEnum {}
